import { booleanParser, encodedStringParser, numberParser, stringParser } from '../inboundParsers';
export const SHOW_NEXT_TOURNEY_WINDOW_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'showOffStageOnly', parser: booleanParser },
        { name: 'updateExistingWindowOnly', parser: booleanParser },
        { name: 'tourneyName', parser: encodedStringParser },
        { name: 'iconLabel', parser: stringParser },
        { name: 'roomId', parser: numberParser },
        { name: 'secondsUntilStart', parser: numberParser },
        { name: 'serverStartTime', parser: numberParser },
        { name: 'mttId', parser: numberParser },
        { name: 'sponsorString', parser: stringParser }
    ]
};
